module.exports = __webpack_public_path__ + "static/media/client-9.99ae4934.jpg";